import Utils from '@/scripts/Utils';
import ConsumptionApi from '@/services/apiPdf/ConsumptionApi.js';
import UsersService from "@/services/server/UsersService";
import UnitsService from "@/services/server/UnitsService";
import ReservoirsService from "@/services/server/ReservoirsService";
import ChartsReservoirLevel from "@/components/charts/ChartsReservoirLevel/ReservoirLevel.vue";
import ConsumptionFunctions from "@/pages/ReservoirLevel/ConsumptionFunctions.js"
import { showErrorSnackBar, showSuccessSnackBar, showInfoSnackBar } from "@/utils/SnackBartHelper"
import debounce from 'lodash/debounce';
import Rules from "@/utils/Rules";
import Tank from "./tank.vue";
import LevelBar from './LevelBar.vue';
import { mapGetters } from 'vuex';

var { DateTime } = require("luxon");

const PROJECT_START_YEAR = '2020'

import { generateXLSX } from "./ReportEconomyXLSX";

export default {

  name: "Consumption",

  components: {
    ChartsReservoirLevel,
    Tank,
    LevelBar,
  },


  data() {
    return {
      selectsLoading: {
        client: false,
        unit: false,
        sector: false
      },
      allowPrinting: false,
      loadingConsultDate: false,
      isDataGraphic: false,
      menuDateStart: false,
      menuDateEnd: false,
      dateSelectedEnd: '',
      data_abstract_client: {
        name: "Selecione um cliente",
        consumptionType: "-/-",
        registry: "-",
        address: "-",
        last_updated: "-"
      },
      readings_table_table1: [],
      readings_table_table2: [],
      loadButtonPdf: false,
      listClients: [],
      selectedClient: null,
      listUnits: [],
      selectedUnit: null,
      listSectors: [],
      readings: [],
      optionMetric: true,
      switch1: "Metros Cúbicos (m³)",
      validDayPeriodSelected: true,
      validHourPeriodSelected: true,
      validMonthPeriodSelected: true,
      consultReading: false,
      optionsToDisplay: [{ label: "Dia", value: "day" }],
      optionToDisplaySelected: "day",
      totalEstimatedConsumption: [],
      dateFormattedSelectedStart: '',
      dateFormattedSelectedEnd: '',
      dateSelectedFormatted: Utils.formatDate(new Date(), "<dd>/<MM>/<YYYY>"),
      dateSelectedStart: '',
      dateSelected: Utils.formatDate(new Date(), "<YYYY>-<MM>-<dd>"),
      menuDate: false,
      byMonth: ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"],
      byYear: Utils.generateYearsByInterval(PROJECT_START_YEAR, 'now').map((date) => Utils.getDateInfo(date, false)['year']),
      monthSelected: '',
      yearSelected: '',
      optionPeriod: '',
      consultGraph: false,
      consultTable: false,
      graphicFlag: false,
      periodModal: false,
      isDataTable: false,
      formatedDateToText: "",
      headers_tabledays: [
        { text: 'Data', align: 'center', sortable: false, value: 'date' },
        { text: 'Medição', value: 'value', align: 'center', },
      ],
      readings_table: [],
      monthListIndex: {
        Janeiro: { month: 1 },
        Fevereiro: { month: 2 },
        Março: { month: 3 },
        Abril: { month: 4 },
        Maio: { month: 5 },
        Junho: { month: 6 },
        Julho: { month: 7 },
        Agosto: { month: 8 },
        Setembro: { month: 9 },
        Outubro: { month: 10 },
        Novembro: { month: 11 },
        Dezembro: { month: 12 }
      },
      loadingReadings: false,
      dateOptions: {
        startDate: DateTime.utc()
          .setZone("America/Sao_Paulo")
          .startOf("day")
          .toSeconds(),
        endDate: DateTime.utc().setZone("America/Sao_Paulo").toSeconds(),
        mode: "day",
      },
      chartMenuItems: ["Últimos 7 dias","Por dia", "Por hora", "Por intervalo"],
      dialog: false,
      resume: {},
      totalDates: 0,
      permittedStartDate: null,
      permittedEndDate: null,
      validForm: false,
      validFormPeriod: false,
      showReservoirs: false,
      selectsModal: true,
      selectedUnits: [],
      selectedSector: [],
      groupingDataGraphic: false,
      loadingCheckNivel: false,
      generateLabels: [],
      totalConsumptionUnitsSelected: false,
      consultDatalLoading: {
        graphicButton: false,
        readingButton: false,
      },
      selectedIdUnits: [],
      multiReadings: [],
      measureUnit: null,
      colors: ["#4092FF","#002E71","#00ACC1","#204980","#007BFF","#1976D2","#009688","#303F9F","#0057B7","#607D8B"],
      loading: false,
      reservoirLoadError: false,
      reservoirRequestVersion: 0,
      reservoirsFromSectorsOnly: false, // true quando listSectors veio só de setores (para reloadDate não sobrescrever)
    };
  },

  computed: {
    ...mapGetters([
      'getSelectedUnits',
      'getSelectedSectors',
    ]),
    unitMeasureVuex() {
      return this.$store.getters.unitMeasure;
    },
    selectedPeriodValueVuex() {
      return this.$store.getters.selectedPeriodValue;
    },
    iconUnitSelect() {
      if (this.likesAllUnits) return 'mdi-close-box'
      if (this.likesSomeUnits) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },
    iconSectorSelect() {
      if (this.likesAllSectors) return 'mdi-close-box'
      if (this.likesSomeSectors) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },
    rulesRequiredArray() {
      return [this.requiredRuleArray()]
    },
    rulesRequired() {
      return Rules.required();
    },
    getNameByIdClient() {
      const client = this.listClients.find(({ id }) => id === this.selectedClient)
      return client ? client.name : ""
    },
    allFieldsReady() {
      const mode = this.getCurrentPeriodMode()
      return mode == 'day' || mode == '7days' || mode == 'estimed' || mode == 'interval'
        ? this.totalDates <= 90 : mode == 'hour'
        ? this.totalDates <= 24 : mode == 'month'
        ? this.totalDates <= 12 : false;
    },
    isCubicMetersSelected() {
      return this.switch1 == 'Metros Cúbicos (m³)'
    },
    unitMeasurement() {
      return this.isCubicMetersSelected ? 'cubic_meters' : 'liters'
    },
    hasReservoirSelection() {
      return this.getSelectedUnitIds().length > 0 || this.getReservoirSectorsFromSelection().length > 0
    },
    reservoirEmptyState() {
      if (this.reservoirLoadError) {
        return {
          icon: 'mdi-alert-circle-outline',
          title: 'Não foi possível carregar os reservatórios',
          description: 'Tente novamente. Se o problema continuar, entre em contato com o suporte.',
        }
      }
      return {
        icon: 'mdi-water',
        title: 'Selecione unidade(s) e/ou reservatório(s)',
        description: 'Use o painel à direita para escolher as unidades e os reservatórios que deseja visualizar.',
      }
    },
    
  },

  methods: {
    startDateCalendar() {

      this.periodModal = true

			const date = Utils.formatDate(new Date(), "<YYYY>-<MM>-<dd>");
			this.maxStartDate = date
		},
    getCurrentPeriodMode() {
      const options = this.dateOptions || {}
      return options.mode || options.period || 'day'
    },
    syncDateOptionsMode(mode) {
      if (!this.dateOptions) this.dateOptions = {}
      this.dateOptions.mode = mode
      this.dateOptions.period = mode
    },
    normalizeHourPeriodRange() {
      if (this.getCurrentPeriodMode() !== 'hour' || !this.dateOptions?.startDate) return

      const startDate = this.dateOptions.startDate
      this.dateOptions.startDate = Utils.instanceDate(`${startDate.getFullYear()}-${startDate.getMonth()+1}-${startDate.getDate()} 00:00:00`)
      this.dateOptions.endDate = Utils.instanceDate(`${startDate.getFullYear()}-${startDate.getMonth()+1}-${startDate.getDate()} 23:59:59`)
    },
    normalizeReservoirPeriodRange() {
      const mode = this.getCurrentPeriodMode()
      if (!this.dateOptions?.startDate) return

      if (mode === 'hour') {
        this.normalizeHourPeriodRange()
        return
      }

      if (mode !== 'interval' || !this.dateOptions.endDate) return

      const startDate = this.dateOptions.startDate
      const endDate = this.dateOptions.endDate
      this.dateOptions.startDate = Utils.instanceDate(`${startDate.getFullYear()}-${startDate.getMonth()+1}-${startDate.getDate()} 00:00:00`)
      this.dateOptions.endDate = Utils.instanceDate(`${endDate.getFullYear()}-${endDate.getMonth()+1}-${endDate.getDate()} 23:59:59`)
    },
    updateReservoirSector(updatedSector) {
      if (!updatedSector?.id_doc) return updatedSector

      this.listSectors = this.listSectors.map((item) => (
        item.id_doc === updatedSector.id_doc ? updatedSector : item
      ))

      if (!Array.isArray(this.selectedSector) && this.selectedSector?.id_doc === updatedSector.id_doc) {
        this.selectedSector = updatedSector
      }

      return updatedSector
    },
    getSelectedUnitIds() {
      return (this.getSelectedUnits || []).map(unit => unit.id || unit).filter(Boolean)
    },
    getReservoirSectorsFromSelection() {
      return (this.getSelectedSectors || []).filter(sector => sector.waterSupplyType === 'RESERVOIR')
    },
    getReservoirSelectionKey() {
      const unitIds = this.getSelectedUnitIds().map(String).sort()
      const sectorIds = this.getReservoirSectorsFromSelection()
        .map(sector => String(sector.id_doc || sector.id || ''))
        .filter(Boolean)
        .sort()
      return `${unitIds.join(',')}|${sectorIds.join(',')}`
    },
    isCurrentReservoirRequest(requestVersion, selectionKey) {
      return requestVersion === this.reservoirRequestVersion
        && selectionKey === this.getReservoirSelectionKey()
    },
    colorizeMultiReadings(readings) {
      const estimatedPointColor = '#FF9800'
      const applyReservoirPointColors = (pointColors, lineColor) => {
        if (!Array.isArray(pointColors)) return lineColor
        return pointColors.map((pointColor) => (
          pointColor === estimatedPointColor ? estimatedPointColor : lineColor
        ))
      }

      return (readings || []).map((reading, index) => {
        if (!reading?.datasets?.[0]) return reading
        const lineColor = this.colors[index % this.colors.length]
        return {
          ...reading,
          datasets: reading.datasets.map((dataset, datasetIndex) => {
            if (datasetIndex !== 0) return dataset
            return {
              ...dataset,
              borderColor: lineColor,
              backgroundColor: lineColor,
              pointBackgroundColor: applyReservoirPointColors(dataset.pointBackgroundColor, lineColor),
              pointBorderColor: applyReservoirPointColors(dataset.pointBorderColor, lineColor),
            }
          }),
        }
      })
    },
    applyReservoirLevelPayload(payload) {
      const data = payload || {}
      this.listSectors = data.listSectors || []
      this.multiReadings = []
      this.readings = data.readings || []
      this.readings_table = []
      this.resume = data.resume || {}
      this.generateLabels = []
      this.permittedStartDate = data.permittedStartDate || null
      this.permittedEndDate = data.permittedEndDate || null
      this.totalDates = 0
      this.showReservoirs = this.listSectors.length > 0
    },
    async fetchReservoirLevelPayload({ unitIds = null, sectors = null, restrictToSelectedSectors = false, applyPayload = true } = {}) {
      const currentSelectedUnitIds = this.getSelectedUnitIds()
      const selectedUnitIds = unitIds !== null
        ? unitIds
        : (currentSelectedUnitIds.length ? currentSelectedUnitIds : this.selectedIdUnits)
      const selectedSectors = sectors !== null ? sectors : this.getReservoirSectorsFromSelection()
      const response = await ReservoirsService.getLevelPayload({
        unitIds: selectedUnitIds,
        sectors: selectedSectors,
        dateOptions: this.dateOptions,
        unitMeasure: this.unitMeasureVuex,
        restrictToSelectedSectors,
      })
      const payload = response.data?.data || {}
      if (applyPayload) this.applyReservoirLevelPayload(payload)
      return payload
    },
    requiredRuleArray(errorText = 'Campo requerido') {
      return value => value === null || !value.length ? errorText : true;
    },
    toggleUnitsList() {
      this.$nextTick(() => {
        if (this.likesAllUnits) {
          this.selectedUnits = []
        } else {
          this.selectedUnits = this.listUnits.slice().map((unit => unit.id))
        }
        this.onChangeUnit(this.selectedUnits)
      })
    },
    async getSectorsByUnitId(idUnits, suppressEmptyMessage = false) {
      await this.fetchReservoirLevelPayload({ unitIds: idUnits || [], sectors: [] })


      if (!suppressEmptyMessage && !this.listSectors.length) showInfoSnackBar("A seleção atual não possui reservatórios configurados.")
      
    },

    async getModensBySectors() {
      await this.fetchReservoirLevelPayload({ sectors: this.listSectors, restrictToSelectedSectors: true })
    },

    onKeydownSector(key) {
      if (key.code === 'Backspace') {
        this.closeInfoData();
        this.selectedSector = null;
      }
    },
    onChangeSector(sector) {
      this.readings_table = []
      this.groupingDataGraphic = false
      this.isDataGraphic = false;
      this.isDataTable = false;
    },
    onKeydownUnit(key) {
      if (key.code === 'Backspace') {
        this.closeInfoData();
        this.selectedUnit = null;
        this.selectedSector = null;
        this.listSectors = [];
      }
    },
    async onChangeUnit(idUnits) {
      this.listSectors = [];
      this.selectedSector = [];
      this.selectedIdUnits = idUnits;
      this.selectsLoading.sector = true
      // await this.getSectorsByUnitId(idUnits)
      this.closeInfoData();
      this.selectedSector = [];
      this.selectsLoading.sector = false
      // if (this.listSectors.length === 1) this.selectedSector = this.listSectors; 
    },
    onKeydownClient(key) {
      if (key.code === 'Backspace') {
        this.closeInfoData();
        this.selectedClient = null;
        this.selectedUnit = null;
        this.listUnits = [];
        this.selectedSector = null;
        this.listSectors = [];
      }
    },
    async onChangeClient(idClient) {
      this.selectsLoading.unit = true
      this.closeInfoData();
      this.selectedUnits = [];
      this.selectedSector = [];

      const response = await UnitsService.findAllByClient(idClient)
      this.listUnits = response.data.data
      this.selectsLoading.unit = false
      if (this.listUnits.length === 1) {
        this.selectedUnits = [this.listUnits[0].id];
        this.onChangeUnit(this.selectedUnits);
      }
    },
    /**
     * Está função gera um estrutura para gerar o excel baseados nos
     * dados resumidos
     */
    async exportSheets() {
      let excelData = {
        unit_name: this.selectedUnit.name,
        sectors: []
      }
      let resumeValues = Object.values(this.resume)
      for (let i = 0; i < resumeValues.length; i++) {
        let resume = resumeValues[i]
        let modemName = resume['modemName']
        let rows = []
        rows.push(modemName)
        resume.readings.forEach(
          (reading) => {
            let row = [reading.label, reading.water_liters.toFixed(0), reading.water_cubic_meters.toFixed(3)]
            rows.push(row)
          }
        )
        let lastRow = ['Total', resume.total_liters.toFixed(0), resume.total_cubic_meters.toFixed(3)]
        rows.push(lastRow)
        excelData.sectors.push(rows)
      }
      await generateXLSX(excelData)
    },
    estimatedConsumption(total, estimated) {
      let sum = total + estimated
      return sum.toFixed(2)
    },
    closeInfoData() {
      this.data_abstract_client = {
        name: "Selecione um cliente",
        consumptionType: "-/-",
        registry: "-",
        address: "-",
        last_updated: "-"
      };
      this.isDataGraphic = false;
      this.isDataTable = false;
      this.allowPrinting = false;

    },
    async loadReservoirsFromSelection(requestVersion = this.reservoirRequestVersion) {
      this.showReservoirs = false
      this.loadingCheckNivel = true
      this.reservoirLoadError = false
      this.reservoirsFromSectorsOnly = false

      const selectedUnitIds = this.getSelectedUnitIds()
      const reservoirSectors = this.getReservoirSectorsFromSelection()
      const hasSelection = selectedUnitIds.length > 0 || reservoirSectors.length > 0
      const selectionKey = this.getReservoirSelectionKey()

      try {
        if (hasSelection) {
          const sectorsPayload = selectedUnitIds.length
            ? reservoirSectors.filter(sector => !selectedUnitIds.includes(sector.id_unit))
            : reservoirSectors
          this.selectedUnits = this.getSelectedUnits || []
          this.selectedIdUnits = selectedUnitIds.length
            ? selectedUnitIds
            : [...new Set(reservoirSectors.map(sector => sector.id_unit))]
          this.reservoirsFromSectorsOnly = selectedUnitIds.length === 0 && reservoirSectors.length > 0
          const payload = await this.fetchReservoirLevelPayload({
            unitIds: selectedUnitIds,
            sectors: sectorsPayload,
            applyPayload: false,
          })
          if (!this.isCurrentReservoirRequest(requestVersion, selectionKey)) return null
          this.applyReservoirLevelPayload(payload)
        } else {
          this.listSectors = []
          this.selectedIdUnits = []
          this.selectedUnits = []
          this.multiReadings = []
          this.showReservoirs = false
        }

        this.closeInfoData()
        this.selectedSector = []
        this.onChangeSector(this.listSectors)
        this.selectsModal = false
        return hasSelection
      } catch (error) {
        if (!this.isCurrentReservoirRequest(requestVersion, selectionKey)) return null
        this.reservoirLoadError = true
        this.listSectors = []
        this.multiReadings = []
        this.showReservoirs = false
        showErrorSnackBar("Não foi possível carregar os reservatórios. Tente novamente.")
        return false
      } finally {
        if (requestVersion === this.reservoirRequestVersion) {
          this.loadingCheckNivel = false
        }
      }
    },

    async getLevelReadings(){
      if (this.$refs.formConsumption && !this.$refs.formConsumption.validate()) return;
      this.showReservoirs = false
      this.isDataGraphic = false;
      this.loadingCheckNivel = true
      await this.loadReservoirsFromSelection()
    },
    async startConsultTable(sector) {
      
      // Ativa flags que permite fazer a impressão e também flag de carregamento dos dados (vue loading)
      this.allowPrinting = true;
      this.loadingReadings = true;
      this.readings_table = []
      this.validDayPeriodSelected = true;
      this.validHourPeriodSelected = true;
      this.validMonthPeriodSelected = true;

      const payload = await this.fetchReservoirLevelPayload({
        sectors: [sector],
        restrictToSelectedSectors: true,
        applyPayload: false,
      })
      const updatedSector = (payload.listSectors || []).find((item) => item.id_doc === sector.id_doc)
      if (updatedSector) {
        sector = this.updateReservoirSector(updatedSector)
      }

      await this.generateAllConsumption(false,sector)
      if (!this.allFieldsReady) {
        this.loadingReadings = false;
        return;
      }

      this.readings_table = ConsumptionFunctions.createDataTable(this.resume,sector)
      if (this.isCubicMetersSelected) {
        this.headers_tabledays = [
          { text: 'Data', align: 'center', sortable: false, value: 'date' },
          { text: 'Medição (m³)', value: 'value', align: 'center', },
        ]
      } else {
        this.headers_tabledays = [
          { text: 'Data', align: 'center', sortable: false, value: 'date' },
          { text: 'Medição (L)', value: 'value', align: 'center', },
        ]
      }
      this.consultReading = false;
      this.isDataGraphic = false;        // Não exibe gráfico
      this.isDataTable = true;
      this.consultGraph = false;
      this.loadingReadings = false;
    },
    getResumeData(modemId, key) {
      if (!this.resume.hasOwnProperty(modemId)) throw new Error(`Não foi encontrado o modem '${modemId}' no resumo dos dados`)
      let resumeModem = this.resume[modemId]
      if (!resumeModem.hasOwnProperty(key)) throw new Error(`Não foi encontrado o dado '${key}' no resumo dos dados`)
      return resumeModem[key]
    },
    generateModemIds() {
      let modems = []
      if (!Array.isArray(this.selectedSector)) {
        modems.push(this.selectedSector)
      } else {
        modems = this.selectedSector
      }
      let modemIds = modems.map((modem) => modem.id_modem)
      return modemIds
    },
    async generateAllConsumption(isToPredict = true, sector) {
      this.resume = {}
      this.readings = []
      let modems = []

      if (!Array.isArray(sector)) {
        modems.push(sector)
      } else {
        modems = sector
      }
      const mode = this.getCurrentPeriodMode()
      if(mode == 'hour'){
        let startDate = this.dateOptions.startDate
        this.dateOptions.endDate = Utils.instanceDate(`${startDate.getFullYear()}-${startDate.getMonth()+1}-${startDate.getDate()} 23:59:59`);
      }
      if(this.dateOptions.endDate == null || this.dateOptions.startDate == null){
        const day = new Date().getDate()
        const month = new Date().getMonth()
        const year = new Date().getFullYear()
        this.dateOptions.startDate = Utils.instanceDate(`${year}-${month+1}-${day} 00:00:00`);
        this.dateOptions.endDate = Utils.instanceDate(`${year}-${month+1}-${day} 23:59:59`);
        this.syncDateOptionsMode("hour")
      }


      this.formatedDateToText = `De ${Utils.formatDate(this.dateOptions.startDate, "<dd>/<MM>/<YYYY>")} a ${Utils.formatDate(this.dateOptions.endDate, "<dd>/<MM>/<YYYY>")}`
      let { permittedStartDate, permittedEndDate, formatedReadings, labels } = await ConsumptionFunctions.generateConsumption(
        this.dateOptions.startDate,
        this.dateOptions.endDate,
        this.getCurrentPeriodMode(),
        modems,
        this.unitMeasurement,
        isToPredict,
        sector
      )
      this.generateLabels = labels
      this.permittedStartDate = permittedStartDate;
      this.permittedEndDate = permittedEndDate;
      this.totalDates = labels.length;
      this.resume = formatedReadings;
    },
    async setPeriodDate(){
      this.loadingConsultDate = true
      if (this.$refs.formDatePeriod && !this.$refs.formDatePeriod.validate()) return;
      let startDate, endDate;
      switch (this.optionPeriod) {
        case 'Últimos 7 dias': {
          const todayMidnight = Utils.getMidnightToday();
          startDate = Utils.add_day(todayMidnight, -7);
          endDate = Utils.getLastDateOfDay(todayMidnight);
          this.syncDateOptionsMode("day")
          break;
        }
        case 'Por dia': {
          this.yearSelected = parseInt(this.yearSelected);
          startDate = Utils.instanceDate(`${this.yearSelected}-${this.monthListIndex[this.monthSelected].month}`);
          const lastDay = Utils.getLastDayOfMonth(startDate);
          endDate = Utils.getLastDateOfDay(lastDay);
          this.syncDateOptionsMode("day")
          break;
        }
        case 'Por hora': {
          const [year, month, day] = this.dateSelected.split('-').map(num => parseInt(num));
          startDate = Utils.instanceDate(`${year}-${month}-${day} 00:00:00`);
          endDate = Utils.instanceDate(`${year}-${month}-${day} 23:59:59`);
          this.syncDateOptionsMode("hour")
          break;
        }
        case 'Por intervalo': {
          const [startYear, startMonth, startDay] = this.dateSelectedStart.split('-').map(Number);
          const [endYear, endMonth, endDay] = this.dateSelectedEnd.split('-').map(Number);
          if(new Date(this.dateSelectedStart) > new Date(this.dateSelectedEnd)){
            endDate = Utils.instanceDate(`${startYear}-${startMonth}-${startDay} 00:00:00`);
            startDate = Utils.instanceDate(`${endYear}-${endMonth}-${endDay} 23:59:59`);
          }else{
            startDate = Utils.instanceDate(`${startYear}-${startMonth}-${startDay} 00:00:00`);
            endDate = Utils.instanceDate(`${endYear}-${endMonth}-${endDay} 23:59:59`);
          }
          this.syncDateOptionsMode(this.optionToDisplaySelected)
          break;
        }
        default: {
          const now = new Date();
          const day = now.getDate();
          const month = now.getMonth() + 1;
          const year = now.getFullYear();
          startDate = Utils.instanceDate(`${year}-${month}-${day} 00:00:00`);
          endDate = Utils.instanceDate(`${year}-${month}-${day} 23:59:59`);
          this.syncDateOptionsMode("hour")
        }
      }
      this.dateOptions.startDate = startDate;
      this.dateOptions.endDate = endDate;

      const reading = await this.buildSectorChartReading(this.selectedSector, { showEmptyMessage: true })
      if (reading) {
        this.readings = [reading]
        this.consultReading = false;
        this.loadingReadings = false;
        this.consultGraph = false;
        this.isDataGraphic = true;
        this.periodModal = false
      } else {
        this.loadingReadings = false;
      }
      this.loadingConsultDate = false
    },

    async buildSectorChartReading(sector, { showEmptyMessage = false, refreshSeries = true } = {}) {
      if (!sector) return null

      if (refreshSeries) {
        const payload = await this.fetchReservoirLevelPayload({
          sectors: [sector],
          restrictToSelectedSectors: true,
          applyPayload: false,
        })
        const updatedSector = (payload.listSectors || []).find((item) => item.id_doc === sector.id_doc)
        if (updatedSector) {
          sector = this.updateReservoirSector(updatedSector)
        }
      }

      await this.generateAllConsumption(true, sector)
      if (!this.allFieldsReady) return null
      if (!this.resume?.length || !this.resume[0]?.length) {
        if (showEmptyMessage) showInfoSnackBar("Não há leituras disponíveis para este reservatório no período selecionado.")
        return null
      }

      const readings = ConsumptionFunctions.createDataset(this.resume, sector, this.generateLabels)
      return readings?.[0] || null
    },
    async consultConsumptionGraphic(sector) {
       if(sector != undefined){
         this.optionPeriod = null
         this.selectedSector = sector
         this.consultDatalLoading.graphicButton = true
         this.isDataTable = false;
         this.allowPrinting = true;
         this.loadingReadings = true;
         this.validDayPeriodSelected = true;
         this.validHourPeriodSelected = true;
         this.validMonthPeriodSelected = true;
         const reading = await this.buildSectorChartReading(sector, { showEmptyMessage: true })
         if (reading) {
           this.readings = [reading]
           this.consultReading = false;
           this.loadingReadings = false;
           this.consultGraph = false;
           this.periodModal = false
         } else {
           this.loadingReadings = false;
         }
         this.consultDatalLoading.graphicButton = false
       }

    },
    async startPdf() {
      try {
        this.loadButtonPdf = true
        let modemIds = this.generateModemIds()
        let unitId = this.selectedUnit.id
        let dateOptions = Utils.copyObject(this.dateOptions)
        let unitMeasurement = this.unitMeasurement
        const params = {
          unitId,
          modemIds,
          unitMeasurement,
          ...dateOptions
        }
        await ConsumptionApi.generateConsumptionPdf(this.data_abstract_client.name, params)
        this.loadButtonPdf = false
      } catch {
        this.loadButtonPdf = false
        alert("Ocorreu um erro não identificado, entre em contato com nossa equipe de suporte.")
      }
    },
    formatDate(date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    debouncedGetSectors: debounce(function (e) {
      this.onChangeUnit(e);
    }, 1000),
    scheduleReservoirReload: debounce(function (requestVersion) {
      this.reloadDate(requestVersion)
    }, 75),
    queueReservoirReload() {
      const requestVersion = ++this.reservoirRequestVersion
      this.loading = this.hasReservoirSelection
      if (!this.hasReservoirSelection) {
        this.listSectors = []
        this.multiReadings = []
        this.readings = []
        this.showReservoirs = false
        this.reservoirLoadError = false
      }
      this.scheduleReservoirReload(requestVersion)
    },
    async reloadDate(requestVersion = null){
      const currentRequestVersion = Number.isInteger(requestVersion)
        ? requestVersion
        : ++this.reservoirRequestVersion
      const selectionKey = this.getReservoirSelectionKey()
      if (!this.isCurrentReservoirRequest(currentRequestVersion, selectionKey)) return

      this.loading = this.hasReservoirSelection
      try {
        const hasSelection = await this.loadReservoirsFromSelection(currentRequestVersion)
        if (!this.isCurrentReservoirRequest(currentRequestVersion, selectionKey)) return
        if (!hasSelection || !this.listSectors.length) {
          this.multiReadings = []
          return
        }

        const sectors = [...this.listSectors]
        const chartReadings = []

        for (const sector of sectors) {
          const reading = await this.buildSectorChartReading(sector, { refreshSeries: false })
          if (!this.isCurrentReservoirRequest(currentRequestVersion, selectionKey)) return
          if (reading) chartReadings.push(reading)
        }

        this.multiReadings = this.colorizeMultiReadings(chartReadings)
      } catch (error) {
        if (!this.isCurrentReservoirRequest(currentRequestVersion, selectionKey)) return
        this.multiReadings = []
        showErrorSnackBar("Não foi possível carregar o histórico dos reservatórios. Tente novamente.")
      } finally {
        if (currentRequestVersion === this.reservoirRequestVersion) {
          this.loading = false
        }
      }
    },
    hexToRgba(hex, alpha) {
      let r = 0, g = 0, b = 0;
  
      if (hex.length === 4) {
        r = parseInt(hex[1] + hex[1], 16);
        g = parseInt(hex[2] + hex[2], 16);
        b = parseInt(hex[3] + hex[3], 16);
      } else if (hex.length === 7) {
        r = parseInt(hex.substring(1, 3), 16);
        g = parseInt(hex.substring(3, 5), 16);
        b = parseInt(hex.substring(5, 7), 16);
      }
  
      return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    },
  },

  watch: {
    getSelectedUnits: {
      handler(newUnit) {
        this.selectedUnits = newUnit || []
        this.selectedIdUnits = (newUnit || []).map(unit => unit.id)
        this.multiReadings = []
        this.queueReservoirReload()
      }
    },
    getSelectedSectors: {
      handler() {
        this.multiReadings = []
        this.queueReservoirReload()
      }
    },
    optionMetric() {
      if (this.optionMetric == true) {
        this.switch1 = "Metros Cúbicos (m³)";
      } else {
        this.switch1 = "Litros (L)";
      }
    },
    dateSelectedEnd() {
      this.dateFormattedSelectedEnd = this.formatDate(this.dateSelectedEnd);
    },
    dateSelectedStart() {
      this.dateFormattedSelectedStart = this.formatDate(this.dateSelectedStart);
    },
    dateSelected() {
      this.dateSelectedFormatted = this.formatDate(this.dateSelected);
    },
    unitMeasureVuex(newVal) {
      this.queueReservoirReload()
    },
    selectedPeriodValueVuex(newVal){
      this.dateOptions = structuredClone(newVal || {})
      this.syncDateOptionsMode(this.getCurrentPeriodMode())
      this.normalizeReservoirPeriodRange()
      const mode = this.getCurrentPeriodMode()
      const estimatedPeriodIsReady = mode === "estimed"
        && this.dateOptions.startDate
        && this.dateOptions.endDate

      if (mode !== "estimed" || estimatedPeriodIsReady) {
        this.queueReservoirReload()
      }
    },
  },
  async created() {
    this.selectsLoading.client = true
    const response = await UsersService.findAllClients()
    this.listClients = response.data.data
    this.selectsLoading.client = false
    if (this.listClients.length === 1) {
      this.selectedClient = this.listClients[0]
      this.onChangeClient(this.selectedClient.id)
    }
    this.dateOptions = structuredClone(this.selectedPeriodValueVuex || {})
    this.syncDateOptionsMode(this.getCurrentPeriodMode())
    this.normalizeReservoirPeriodRange()
    this.selectedUnits = this.getSelectedUnits || []
    this.selectedIdUnits = (this.getSelectedUnits || []).map(unit => unit.id)
    await this.reloadDate()
  },
  beforeDestroy() {
    this.scheduleReservoirReload.cancel()
  },
};
